import { FC } from 'react';
import styled from 'styled-components';
import { ScreenSize, useScreenSize } from '../../contexts/ScreenSizeContext';

import {
  frontendSkills,
  backendSkills,
  aiSkills,
  programmingLanguages,
  Skill,
} from '../../consts/skill';
import { darkTheme } from '../../consts/themes';

const HeaderContainer = styled.header`
  background: rgb(5, 5, 7);
  min-height: 800px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 2rem 2rem 1rem;
  color: white;

  /* Increase bottom padding on mobile */
  @media (max-width: 600px) {
    padding-bottom: 3rem;
  }
`;

const ContentContainer = styled.div<{ $screenSize: ScreenSize }>`
  max-width: 1000px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? 'center' : 'left'};
`;

const MainTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 3rem;
  text-align: center;
`;

const SkillsetContainer = styled.div<{ $screenSize: ScreenSize }>`
  display: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? 'grid' : 'block'};
  grid-template-columns: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? 'repeat(2, 1fr)' : 'none'};
  gap: 1em;
`;

const Container = styled.div<{ $screenSize: ScreenSize }>`
  display: flex;
  flex-direction: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? 'column' : 'row'};
  justify-content: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? 'center' : 'space-evenly'};
`;

const SkillTitle = styled.div<{ $screenSize: ScreenSize }>`
  font-size: 1.5rem;
  font-weight: 600;
  margin: 20px 0;
  width: 100%;
  text-align: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? 'center' : 'left'};
`;

const Item = styled.div<{ $screenSize: ScreenSize }>`
  display: flex;
  color: ${darkTheme.fontColorSecondary};
  text-align: left;
  margin-bottom: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? '0' : '10px'};
`;

const skillsets = [
  { skillset: frontendSkills, title: 'Frontend' },
  { skillset: backendSkills, title: 'Backend' },
  { skillset: aiSkills, title: 'AI' },
  { skillset: programmingLanguages, title: 'Languages' },
];

const Text = styled.div`
  margin-left: 10px;
`;

const Skills: FC = () => {
  const { screenSize } = useScreenSize();
  return (
    <HeaderContainer id="skills">
      <ContentContainer $screenSize={screenSize}>
        <MainTitle>Skills</MainTitle>
        <Container $screenSize={screenSize}>
          {skillsets.map((set) => {
            const { skillset, title } = set;
            return (
              <div key={title}>
                <SkillTitle $screenSize={screenSize}>{title}</SkillTitle>
                <SkillsetContainer $screenSize={screenSize}>
                  {skillset.map((skill: Skill) => {
                    const { text, icon: IconComponent } = skill;
                    return (
                      <Item key={text} $screenSize={screenSize}>
                        {IconComponent ? IconComponent({}) : '●'}
                        {'    '}
                        {<Text>{text.toUpperCase()}</Text>}
                      </Item>
                    );
                  })}
                </SkillsetContainer>
              </div>
            );
          })}
        </Container>
      </ContentContainer>
    </HeaderContainer>
  );
};

export default Skills;
